<template>
  <div>
    <h1 class="page-header">{{ $t('level.level') }}</h1>
    <div class="row">
      <div class="col-lg-3 col-md-5 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <form-create
              @success_create="fetchData"
              :edit="edit_data"
              :leave="route_leave"
              @success_update="edit_data = ''"
              @cancel="fetchData"
            ></form-create>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-lg-9 col-md-7 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <div class="row">
              <div
                class="col-lg-9 com-md-9 col-sm-12 d-flex justify-content-start"
              >
                <p class="ts-text-gray-500">
                  <b
                    ><i
                      ><span class="text-danger">* </span>{{ $t('level.note') }}
                    </i></b
                  >
                  {{ $t('level.onlyuseratheadofficecanmodifyordelete') }}
                </p>
              </div>
              <div
                class="col-lg-3 com-md-3 col-sm-12 d-flex justify-content-end"
              >
                <ts-input
                  v-model="search"
                  :placeholder="$t('search')"
                  style="width: 300px"
                  class="kh-font"
                />
              </div>
            </div>
          </ts-card-wrapper>
          <div class="overflow-auto">
            <ts-loading-banner :loading="exporting">
              <Table
                :columns="columns"
                :data="resources"
                :loading="loading"
                max-height="700"
                stripe
                highlight-row
                 size="small"
              >
                <template slot-scope="{ row }" slot="acps_name_foreign">
                  {{
                    row.sub_program !== null
                      ? row.sub_program.acps_name_foreign
                      : ''
                  }}
                </template>
                <template slot-scope="{ row }" slot="action">
                  <a
                    href="#"
                    title="edit"
                    class="text-primary mr-2"
                    @click.prevent="edit(row)"
                  >
                    <i class="fas fa-edit"></i>
                  </a>
                  <a
                    href="#"
                    title="delete"
                    class="text-danger"
                    @click.prevent="destroy(row.level_id)"
                  >
                    <i class="fas fa-trash"></i>
                  </a>
                </template>
              </Table>
            </ts-loading-banner>
          </div>
          <div class="d-flex justify-content-between align-items-center p-15">
            
            <ts-pagination
              v-model="pagination"
              @navigate="fetchData"
            ></ts-pagination>
          </div>
        </ts-card>
      </div>
    </div>
  </div>
</template>
<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FormCreate from './form.vue'

export default {
  components: {
    FormCreate
  },
  name: 'level',
  props: ['editData'],
  data () {
    return {
      edit_data: this.editData,
      loading: false,
      route_leave: false,
      exporting: false
    }
  },
  created () {
    this.fetchData()
  },
  computed: {
    ...mapState('level', ['resources', 'pagination']),
    search: {
      get () {
        return this.$store.state.level.search
      },
      set (newVal) {
        this.$store.commit('level/SET_SEARCH', newVal)
        this.$store.commit('level/RESET_CURRENT_PAGE')
      }
    },
    columns () {
      return [
        {
          title: this.$t('level.nameKh'),
          key: 'level_name_native',
          minWidth: 120
        },
        {
          title: this.$t('level.nameEn'),
          key: 'level_name_foreign',
          minWidth: 120
        },
        {
          title: this.$t('level.abbreviation'),
          key: 'level_abbr',
          minWidth: 40
        },
        {
          title: this.$t('level.subProgram'),
          slot: 'acps_name_foreign',
          minWidth: 120
        },
        {
          title: this.$t('actions'),
          key: 'action',
          slot: 'action',
          fixed: 'right',
          align: 'center',
          width: 100
        }
      ]
    }
  },
  methods: {
    fetchData (attributes) {
      this.loading = true

      this.$store
        .dispatch('level/fetch', attributes)
        .then(() => (this.loading = false))
        .catch(error => {
          this.$toasted.error(error.message)
          this.loading = false
        })
    },

    edit (data) {
      this.route_leave = false
      this.edit_data = data
      this.$router.push(`/levels/${data.level_id}`)
    },

    async destroy (id) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        this.$store
          .dispatch('level/delete', id)
          .then(response => {
            this.$toasted.success(response.message)
            this.fetchData()
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
      }
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave (to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'level-create') {
      this.$store.commit('level/RESET_STATE')
      this.$store.commit('level/SET_SUB_PROGRAMS', [])
      this.fetchData()
      this.route_leave = true
    }
    next()
  }
}
</script>
